import { ONBOARDING_NCA_TAGS } from './tags';
import {
  AutorizacaoVisualizadaInput,
  ORIGEM_NCA_LINK,
  OnboardingNcaBaseMetadata,
  TrackingSDKLike,
} from './types';

const baseMetadata = (): OnboardingNcaBaseMetadata => ({
  origem: ORIGEM_NCA_LINK,
});

export const makeOnboardingNcaTrack = (sdk: TrackingSDKLike) => ({
  /**
   * Dispara a cada carga da tela de onboarding originada pelo link da NCA.
   */
  cnpjCarregado(): void {
    sdk.track(ONBOARDING_NCA_TAGS.CNPJ_CARREGADO, baseMetadata());
  },

  /**
   * Dispara quando a tela de autorização exibe o checkbox da taxa.
   */
  autorizacaoVisualizada({
    percentualExibido,
  }: AutorizacaoVisualizadaInput): void {
    sdk.track(ONBOARDING_NCA_TAGS.AUTORIZACAO_VISUALIZADA, {
      ...baseMetadata(),
      ...(percentualExibido !== undefined && {
        percentual_exibido: percentualExibido,
      }),
    });
  },

  /**
   * Dispara quando o representante confirma o checkbox e avança.
   */
  autorizacaoConfirmada(): void {
    sdk.track(ONBOARDING_NCA_TAGS.AUTORIZACAO_CONFIRMADA, baseMetadata());
  },
});

export type OnboardingNcaTrack = ReturnType<typeof makeOnboardingNcaTrack>;
